import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { computed } from "@vue/composition-api";
export const useIdentificationFieldBindings = options => {
  const {
    bindApplication,
    makeFieldPathReactive
  } = useBindApplication();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentIdentificationPath = computed(() => {
    return `${currentApplicantPath.value}[identifications][${options.identificationIndex.value}]`;
  });
  const identificationType = bindApplication(makeFieldPathReactive(currentIdentificationPath, "[type]"), "");
  const identificationCountry = bindApplication(makeFieldPathReactive(currentIdentificationPath, "[country]"), "");
  const identificationNumber = bindApplication(makeFieldPathReactive(currentIdentificationPath, "[number]"), "");
  return {
    identificationType,
    identificationCountry,
    identificationNumber
  };
};